/* eslint-disable */
(function () {
  const REGISTRY_KEY = 'component-social-share';

  try {
    if (window.wetheme?.webcomponentRegistry?.checkScriptLoaded?.(REGISTRY_KEY)) return;
    window.wetheme?.webcomponentRegistry?.register?.({ key: REGISTRY_KEY });
  } catch (e) {
    // no-op
  }

  const NATIVE_SHARE_SELECTOR = '[data-share-native]';

  function getSharePayload(buttonEl) {
    const wrapper = buttonEl.closest('.social-sharing');
    const payloadEl = wrapper?.querySelector('[data-social-share-url]');

    const url = payloadEl?.dataset?.socialShareUrl || wrapper?.dataset?.permalink || window.location.href;
    const title = payloadEl?.dataset?.socialShareTitle || document.title;

    return { url, title };
  }

  async function copyTextToClipboard(text) {
    if (!text) return false;

    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (e) {
        // fall through
      }
    }

    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(textarea);
      return ok;
    } catch (e) {
      return false;
    }
  }

  function setTemporaryAriaLabel(el, nextLabel) {
    if (!el) return;

    const original = el.getAttribute('aria-label');
    el.setAttribute('aria-label', nextLabel);

    window.setTimeout(() => {
      if (original) el.setAttribute('aria-label', original);
    }, 1500);
  }

  document.addEventListener('click', async (e) => {
    const nativeShareEl = e.target?.closest?.(NATIVE_SHARE_SELECTOR);
    if (nativeShareEl) {
      e.preventDefault();

      const { url, title } = getSharePayload(nativeShareEl);

      if (navigator.share) {
        try {
          await navigator.share({ title, text: title, url });
          return;
        } catch (err) {
          // fall back to copy
        }
      }

      const copied = await copyTextToClipboard(url);
      if (copied) setTemporaryAriaLabel(nativeShareEl, 'Link copied');
      return;
    }
  });
})();
